import { useContext } from 'react';
import { HomeContext, HomeContextType } from '#home/contexts';

const useHomeContext = () => useContext<HomeContextType>(HomeContext);

export { useHomeContext };
